import Vue from 'vue'
import Router from 'vue-router'
import VueHead from 'vue-head'
import VueScrollTo from 'vue-scrollto'
import Home from '@/pages/Home'
import About from '@/pages/About'
import ProductAnt from '@/pages/ProductAnt'
import ProductCockroach from '@/pages/ProductCockroach'
import PTipsTips from '@/pages/PTipsTips'
import PTipsTipsRoach from '@/pages/PTipsTipsRoach'
import PTipsTipsAnt from '@/pages/PTipsTipsAnt'
import PTipsTipsGeneral from '@/pages/PTipsTipsGeneral'
import PTipsInsecticideGuide from '@/pages/PTipsInsecticideGuide'
import PTipsPetSafety from '@/pages/PTipsPetSafety'
import PTipsFAQ from '@/pages/PTipsFAQ'
import Shoplist from '@/pages/Shoplist'
import PICockroach from '@/pages/PICockroach'
import PIAnt from '@/pages/PIAnt'
import Terms from '@/pages/Terms'
import Privacy from '@/pages/Privacy'

Vue.use(VueHead)
Vue.use(Router)
Vue.use(VueScrollTo)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/product/ant',
      name: 'ProductAnt',
      component: ProductAnt
    },
    {
      path: '/product/cockroach',
      name: 'ProductCockroach',
      component: ProductCockroach
    },
    {
      path: '/preventiontips/tips',
      name: 'PTipsTips',
      component: PTipsTips
    },
    {
      path: '/preventiontips/tips/roach',
      name: 'PTipsTipsRoach',
      component: PTipsTipsRoach
    },
    {
      path: '/preventiontips/tips/ant',
      name: 'PTipsTipsAnt',
      component: PTipsTipsAnt
    },
    {
      path: '/preventiontips/tips/general',
      name: 'PTipsTipsGeneral',
      component: PTipsTipsGeneral
    },
    {
      path: '/preventiontips/insecticideguide',
      name: 'PTipsInsecticideGuide',
      component: PTipsInsecticideGuide
    },
    {
      path: '/preventiontips/petsafety',
      name: 'PTipsPetSafety',
      component: PTipsPetSafety
    },
    {
      path: '/preventiontips/faq',
      name: 'PTipsFAQ',
      component: PTipsFAQ
    },
    {
      path: '/shoplist',
      name: 'shoplist',
      component: Shoplist
    },
    {
      path: '/pestidentification/cockroach',
      name: 'PICockroach',
      component: PICockroach
    },
    {
      path: '/pestidentification/ant',
      name: 'PIAnt',
      component: PIAnt
    },
    {
      path: '/terms',
      name: 'terms',
      component: Terms
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js